var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ol',{class:{ 'suppress-active-link': _vm.suppressActiveLink }},_vm._l((_vm.alphabet),function(letter){return _c('li',{key:letter,on:{"click":function($event){return _vm.letterClicked(letter)}}},[_c('RouterLink',{staticClass:"link",attrs:{"href":{
        path: `${_vm.basePath ?? ''}/${letter.toLocaleLowerCase()}`,
      },"title":letter}},[_vm._v("\n      "+_vm._s(letter)+"\n    ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }